import React, { Component } from 'react';
import '../assets/css/sliderFullscreen.css';
//import plugins
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';
import 'uikit/dist/js/uikit-icons.min.js';
import nl2br from 'react-newline-to-break';
import { Link } from 'react-router-dom';
import Carousel from 'nuka-carousel';

//import images
import HomepageBg_1 from '../assets/img/homepageBg1.jpg';
import HomepageBg_2 from '../assets/img/homepageBg2.jpg';
import HomepageBg_3 from '../assets/img/homepageBg3.jpg';
import HomepageBg_4 from '../assets/img/homepageBg4.jpg';
import HomepageBg_5 from '../assets/img/homepageBg5.png';


class SliderFullscreen extends Component {

	render() {
		return (
			<div className='sliderFullscreen'>
				<Carousel
					autoplay
					width='100%'
					transitionMode='fade'
					wrapAround
					renderCenterLeftControls={({ previousSlide }) => (<div></div>)}
					renderCenterRightControls={({ previousSlide }) => (<div></div>)}
				>
					<div className='slide'>
						<img src={HomepageBg_5} alt="" width='100%' />
						<div className='content' >
							<h1>{nl2br('使用训练平台\n可以帮助您处理数据集\n引导您进行模型训练')}</h1>
							<Link to={'/train'}><button>开始使用</button></Link>
						</div>
					</div>
					<div className='slide'>
						<img src={HomepageBg_1} alt="" width='100%' />
						<div className='content' >
							<h1>{nl2br('使用CocoMod\n快速实现你的想法')}</h1>
							<Link to='/create'><button>开始编程</button></Link>
						</div>
					</div>
					<div className='slide'>
						<img src={HomepageBg_2} alt="" width='100%' />
						<div className='content' >
							<h1>{nl2br('STEAM教育的\n一体化解决方案')}</h1>
							<Link to='/about'><button>关于我们</button></Link>
						</div>
					</div>
					<div className='slide'>
						<img src={HomepageBg_3} alt="" width='100%' />
						<div className='content' >
							<h1>{nl2br('与大家\n分享你的想法')}</h1>
							<Link to='/create'><button>开始探索</button></Link>
						</div>
					</div>
					<div className='slide'>
						<img src={require('../assets/img/官网banner-二代AI.png')} alt="" width='100%' />
						<div className='content' style={{ top: '70%', left: '22%' }}>
							<Link to='/'>
								<button>点击查看</button>
							</Link>
						</div>
					</div>
				</Carousel>
				{/*<div uk-slideshow="animation:fade; autoplay:true" className='uk-position-relative uk-grid-match uk-grid-small' uk-slider="true">
					<ul className="uk-slideshow-items uk-width-1-1" uk-height-viewport="true">
							<li>
									<img src={HomepageBg_4} alt="" uk-cover="true" />
									<div className='content' >
										<h1 style={{lineHeight:'24px',fontSize:'3em'}}>Basic Kit</h1>
										<h2>入门套件</h2>
										<h2>小小模块 大大梦想</h2>
										<Link to='/cocokit'><button>点击查看</button></Link>
									</div>
							</li>
							<li>
									<img src={HomepageBg_1} alt="" uk-cover="true" />
									<div className='content' >
										<h1>{nl2br('使用CocoMod\n快速实现你的想法')}</h1>
										<Link to='/create'><button>开始创造</button></Link>
									</div>
							</li>
							<li>
									<img src={HomepageBg_2} alt="" uk-cover="true" />
									<div className='content' >
										<h1>{nl2br('STEAM教育的\n一体化解决方案')}</h1>
										<Link to='/about'><button>关于我们</button></Link>
									</div>
							</li>
							<li>
									<img src={HomepageBg_3} alt="" uk-cover="true" />
									<div className='content' >
										<h1>{nl2br('与大家\n分享你的想法')}</h1>
										<Link to='/create'><button>开始探索</button></Link>
									</div>
							</li>
					</ul>
					<ul className="uk-flex toggle uk-position-absolute" >
						<li uk-slideshow-item="0"><a href="#">套件</a></li>
		        <li uk-slideshow-item="1"><a href="#">创造</a></li>
		        <li uk-slideshow-item="2"><a href="#">设计</a></li>
		        <li uk-slideshow-item="3"><a href="#">启发</a></li>
    			</ul>
				</div>*/}
			</div>
		)
	}
}
export default SliderFullscreen;
